import { defineComponent as _defineComponent } from 'vue';
import { computed, ref, watch } from "vue";
import { GalaxyApi } from "@/api";
import { errorMessageAsString, rethrowSimple } from "@/utils/simple-error";
import RelocateLink from "./RelocateLink.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import DescribeObjectStore from "@/components/ObjectStore/DescribeObjectStore.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetStorage',
    props: {
        datasetId: null,
        datasetType: { default: "hda" },
        includeTitle: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const storageInfo = ref(null);
        const errorMessage = ref(null);
        const discarded = computed(() => {
            return storageInfo.value?.dataset_state == "discarded";
        });
        const deferred = computed(() => {
            return storageInfo.value?.dataset_state == "deferred";
        });
        const sourceUri = computed(() => {
            const sources = storageInfo.value?.sources;
            if (!sources) {
                return null;
            }
            const rootSources = sources.filter((source) => !source.extra_files_path);
            if (rootSources.length == 0) {
                return null;
            }
            return rootSources[0]?.source_uri;
        });
        async function fetch() {
            const datasetId = props.datasetId;
            const datasetType = props.datasetType;
            try {
                const { data, error } = await GalaxyApi().GET("/api/datasets/{dataset_id}/storage", {
                    params: {
                        path: { dataset_id: datasetId },
                        query: { hda_ldda: datasetType },
                    },
                });
                if (error) {
                    rethrowSimple(error);
                }
                storageInfo.value = data;
            }
            catch (error) {
                errorMessage.value = errorMessageAsString(error);
            }
        }
        watch(props, fetch, { immediate: true });
        return { __sfc: true, props, storageInfo, errorMessage, discarded, deferred, sourceUri, fetch, RelocateLink, LoadingSpan, DescribeObjectStore };
    }
});
